/*
 * Copyright (c) 2021 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

export const BOT_INFO = 'BOT_INFO';
export const CARD = 'CARD';
export const CAROUSEL = 'CAROUSEL';
export const DATA = 'DATA';
export const GRID = 'GRID';
export const MAPS = 'MAPS';
export const PAUSE = 'PAUSE';
export const SAY = 'SAY';
export const START = 'START';
export const TEXT = 'TEXT';
export const REPLY = 'REPLY';
export const WEBSOCKET = 'WEBSOCKET';
